import { store } from 'store/store';

export const onAxiosRequest = (config) => {
  const headers = store.getState().common.serverHttpHeaders;
  const modifiedConfig = { ...config };
  modifiedConfig.headers = { ...headers, ...modifiedConfig.headers };
  return modifiedConfig;
};

export const onAxiosRequestError = (error) => {
  console.error('Request error:', error);
  return Promise.reject(new Error('Request error'));
};
